export default {
  trends: {
    filters: {
      title: "Filtros",
      trends: "Tendencias",
      allTrends: "Todas las tendencias",
      displayGames: "Mostrar partidos",
      alternateLines: "Líneas alternas",
    },
    list: {
      empty: {
        noPropsAvailable: "No hay props disponibles",
        noTrendsAvailableYet: "Todavía no hay tendencias disponibles",
        needsThreeGamesMinimum: "Se necesitan al menos 3 juegos",
        pendingOddsCheckBack: "Cuotas pendientes. Vuelve más tarde.",
      },
      preview: {
        comboTrendPreview: "Vista previa de combo",
        tryLinematePlus: "Prueba Linemate+",
      },
      actions: {
        addAllLegsToMyPicks: "Agregar todas las selecciones a Mis Picks",
      },
    },
    cheatsheet: {
      title: "Cheatsheet",
      separator: {
        noLongerHundredPercent: "YA NO ES 100% DEBAJO DE ESTO",
      },
    },
    details: {
      labels: {
        trendsInThisParlay: "Tendencias en este parlay",
        straights: "Simples",
        all: "Todo",
        hitRates: "Tasas de acierto",
        perGame: "Por partido",
        against: "en contra",
        rank: "Ranking",
        pitcher: "Lanzador",
        handedness: "Mano",
        defensiveRanking: "Ranking defensivo",
      },
      actions: {
        addAllPicksAsParlay: "Agregar todos los picks como parlay",
        removeAll: "Quitar todo",
      },
    },
  },
};
